import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Find = lazy(() =>
  import(
    /* webpackPrefetch: true */
    /* webpackChunkName: 'find' */
    './Find'
  )
)

export function AsyncFind(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Find..." />}>
      <Find {...props} />
    </Suspense>
  )
}

export default AsyncFind
